import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { DeviceAllRequest } from 'app/models/deviceAllRequest.model';
import { QueryLog } from 'app/models/quey-log.model';
import { SessionLog } from 'app/models/session-log.model';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LogsService {

    query: any[];
    device: any[];
    session: any[];
    onChanged: BehaviorSubject<any>;

    constructor(
        private _httpClient: HttpClient,
        private appConfigService: AppInitializationService,
    ) {
        this.onChanged = new BehaviorSubject({});
    }

    getQuery(companyId: number,page:number,count:number): Promise<Array<QueryLog>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "requests/all/" + companyId+"/"+page+"/"+count)// modifier
                .subscribe((response: any) => {
                    this.query = response;
                    this.onChanged.next(this.query);
                    resolve(response);
                }, reject);
        });
    }

    getQueryCount(companyId: number): Promise<number> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "requests/count/" + companyId)// modifier
                .subscribe((response: any) => {
                    this.query = response;
                    this.onChanged.next(this.query);
                    resolve(response);
                }, reject);
        });
    }


    getDevice(companyId: number): Promise<Array<DeviceAllRequest>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "requests/" + companyId)// modifier
                .subscribe((response: any) => {
                    this.device = response;
                    this.onChanged.next(this.device);
                    resolve(response);
                }, reject);
        });
    }

    getSession(companyId: number): Promise<Array<SessionLog>> {
        return new Promise((resolve, reject) => {
            this._httpClient.get(this.appConfigService.apiConfig["api-url"] + "sessions/" + companyId)
                .subscribe((response: any) => {
                    this.session = response;
                    this.onChanged.next(this.session);
                    resolve(response);
                }, reject);
        });
    }
    setSession(entity: SessionLog): Promise<SessionLog> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "sessions/add", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
    deleteSession(entity: SessionLog): Promise<SessionLog> {

        return new Promise((resolve, reject) => {
            this._httpClient.post(this.appConfigService.apiConfig["api-url"] + "sessions/delete", entity)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }
}
